import { App } from '../App';
import { Common } from '../Common';
import { UI } from '../UI';
import { Artworks } from '../../pages/Artworks';
import { Trims } from '../../pages/Trims';
import { addFileDialog } from './addFileDialog';
import { MockupCompare } from '../MockupCompare';
import { User } from '../User';

import './scss/ministu.scss';

$.fn.rotationInfo = function () {
  let el = $(this),
    tr =
      el.css('-webkit-transform') ||
      el.css('-moz-transform') ||
      el.css('-ms-transform') ||
      el.css('-o-transform') ||
      '',
    info = { rad: 0, deg: 0 };
  if ((tr = tr.match('matrix\\((.*)\\)'))) {
    tr = tr[1].split(',');
    if (typeof tr[0] != 'undefined' && typeof tr[1] != 'undefined') {
      info.rad = Math.atan2(tr[1], tr[0]);
      info.deg = parseFloat(((info.rad * 180) / Math.PI).toFixed(1));
    }
  }
  return info;
};

export const Ministu = (function () {
  let $stuData = {},
    $origArt = {},
    $el = {},
    $currentData = {},
    $currentPanel = {},
    $callback = false,
    $res = [];

  let mapping = {
    data: (data, $sizeQ) => {
      let newArr = [];
      $.each(data.variants, function (k, variant) {
        let newObj = {
          color: variant.color,
          side: data.side,
          frame: data.frame,
          area: {
            w: data.area.w * $sizeQ,
            h: data.area.h * $sizeQ,
            x: data.area.x * $sizeQ,
            y: data.area.y * $sizeQ
          },
          blank: {
            w: variant.blank.w * $sizeQ,
            h: variant.blank.h * $sizeQ,
            uri: variant.blank.uri
          },
          art: {
            w: data.art.w * $sizeQ,
            h: data.art.h * $sizeQ,
            x: data.art.x * $sizeQ,
            y: data.art.y * $sizeQ,
            a: data.art.a,
            uri: data.art.uri
          },
          base: {
            w: getBaseWidth(),
            sq: $sizeQ
          },
          result: data.result || ''
        };
        newArr.push(newObj);
      });
      return newArr;
    },
    dataIn: (data) => {
      let $sizeQ = getBaseWidth() / data.variants[0].blank.w;
      return mapping.data(data, $sizeQ);
    },
    dataOut: () => {
      let data = window['MSTU'];
      let $sizeQ = data.base.sq;
      return mapping.data(data, $sizeQ);
    },
    product: (item, panel) => {
      item.infoVariants = panel.variants;
      return item;
    },
    single: (data, $sizeQ) => {
      return {
        panelType: data.panelType,
        color: data.color,
        area: {
          w: data.area.w * $sizeQ,
          h: data.area.h * $sizeQ,
          x: data.area.x * $sizeQ,
          y: data.area.y * $sizeQ
        },
        frame: data.frame,
        blank: {
          w: data.blank.w * $sizeQ,
          h: data.blank.h * $sizeQ,
          uri: data.blank.uri
        },
        art: {
          w:
            window['MSTU'] && window['MSTU'].changed && window['MSTU'].art ? window['MSTU'].art.w : data.art.w * $sizeQ,
          h:
            window['MSTU'] && window['MSTU'].changed && window['MSTU'].art ? window['MSTU'].art.h : data.art.h * $sizeQ,
          x:
            window['MSTU'] && window['MSTU'].changed && window['MSTU'].art ? window['MSTU'].art.x : data.art.x * $sizeQ,
          y:
            window['MSTU'] && window['MSTU'].changed && window['MSTU'].art ? window['MSTU'].art.y : data.art.y * $sizeQ,
          a: window['MSTU'] && window['MSTU'].changed && window['MSTU'].art ? window['MSTU'].art.a : data.art.a,
          uri: data.art.uri
        },
        base: {
          w: getBaseWidth(),
          sq: $sizeQ
        },
        result: data.result || '',
        // Compare File
        compareFile: MockupCompare.mapping.dataStudio(data.compareFile),
        compareVariants: data.infoVariants.filter((v) => v.compareFile !== null)
      };
    },
    save: () => {
      if (!window['MSTU'] || !window['MSTU'].art) {
        return false;
      }
      let art = window['MSTU'].art;
      if (art.h == 0) {
        art.h = parseFloat($('#art').height().toFixed(2));
      }

      if (art.w == 0) {
        art.w = parseFloat($('#art').width().toFixed(2));
      }

      let sq = window['MSTU'].base.sq;
      let data = {
        W: Math.round(art.w / sq),
        H: Math.round(art.h / sq),
        X: Math.round(art.x / sq),
        Y: Math.round(art.y / sq),
        side: window['MSTU'].side,
        frame: window['MSTU'].frame
      };
      if (art.a != 0) {
        data.A = art.a;
      }

      let currentPanel = {};

      $stuData.panels.forEach((item) => {
        if (item.side === window['MSTU'].side) {
          currentPanel = item;
        }
      });

      let currentArea = {};
      currentPanel.areas.forEach((item) => {
        if (item.panelType === window['MSTU'].panelType) {
          currentArea = item;
        }
      });

      currentArea.art.w = data.W;
      currentArea.art.h = data.H;
      currentArea.art.x = data.X;
      currentArea.art.y = data.Y;
      currentArea.art.a = data.A;
    }
  };

  let init = (elem, id, callback = false) => {
    $el = elem;
    UI.block(elem);

    window['MSTU'] = null;


    $.when(
      App.ajaxData(`prelistings/${User.accountID()}/${id}`),
      App.ajaxData(`DesignStudio/mockup/information/${User.accountID()}/${id}`)
    ).done(function (item, info) {
      if (!item.isSuccess || !info.isSuccess) {
        return;
      }

      // Go back to Referer Url
      let referer = Common.gup('ref');
      if (referer) {
        if (!callback) {
          callback = () => {
            $router.push(referer);
          };
        }
        //history.replaceState(null, document.title, Common.removeQueryValues('ref', document.location.href));
      }

      $stuData = { product: item.object, panels: info.createdObject.panels };
      $callback = callback;

      // Query Params PANEL
      let queryPanel = Common.gup('panel'),
        queryPanels;
      if (queryPanel) {
        queryPanels = $stuData.panels.filter((p) => p.sideName == queryPanel);
        history.replaceState(null, document.title, Common.removeQueryValues('panel', document.location.href));
      }
      $currentPanel = queryPanels?.length ? queryPanels[0] : $stuData.panels[0];
      dataInit();
    });
  };

  let dataInit = (area = null) => {
    let product = mapping.product($stuData.product, $currentPanel);
    let panelTypes = [];
    $currentPanel.areas.forEach((f) => {
      if (area == null && f.frame != null) {
        area = f;
      }
      panelTypes.push({ panelName: f.panelName, panelType: f.panelType });
    });

    if (area == null) {
      area =
        window['MSTU'] && window['MSTU'].panelType
          ? $currentPanel.areas.find((f) => f.panelType == window['MSTU'].panelType)
          : $currentPanel.areas[0];
    }

    if (area.art == null) {
      area.art = { w: 0, h: 0, x: 0, y: 0, a: 0, uri: '' };
    }

    product.frame = area.frame;
    product.currentPanel = area.panelType;
    product.currentAreaSide = $currentPanel.side;
    $currentData = area;
    let variants = $.extend([], $currentPanel.variants);

    // Query Params Color
    let queryColor = Common.gup('color'),
      queryData;
    if (queryColor) {
      queryData = variants.filter((v) => v.color == queryColor);
      history.replaceState(null, document.title, Common.removeQueryValues('color', document.location.href));
    }

    let data = queryData?.length ? queryData[0] : variants[0];

    let img = new Image();
    img.src = data.blank.uri;
    img.onload = () => {
      let blankW = img.naturalWidth;
      let blankH = img.naturalHeight;
      let template = require('./tmpl/ministu.hbs');
      $($el)
        .empty()
        .html(
          template({
            $lang: $lang,
            product: product,
            panels: $stuData.panels,
            panelTypes: panelTypes,
            color: data.color
          })
        );
      // Set page attributes
      UI.currentPageAttr();
      // Set active side menu
      UI.setAsideMenuActive();

      data.blank.w = blankW;
      data.blank.h = blankH;

      data.area = $currentData.area;
      data.art = $currentData.art;
      data.panelType = $currentData.panelType;
      data.frame = $currentData.frame;

      data.infoVariants = $.extend([], $currentPanel.variants);
      data = mapping.single(data, getBaseWidth() / blankW);

      //let data = mapping.dataIn(area)[0];
      $origArt = data.art;
      $router.updatePageLinks();

      ministuInit(data);
      buttonsInit($el, $callback);
      UI.unblock($el);
      UI.unblockPage();
    };
  };

  let propsInit = (data) => {
    let $area = $('#area');
    let $art = $('#art');
    let $imageRot = $('#image');
    let $image = $('#image img');
    let $artNull = $('#image #art-null');
    let $blank = $('#blank');
    let $rotate = $('#rotate');
    let $remove = $('#remove');

    $area.css({
      width: `${data.area.w}px`,
      height: `${data.area.h}px`,
      left: `${data.area.x}px`,
      top: `${data.area.y}px`
    });
    $art.css({ width: `${data.art.w}px`, height: `${data.art.h}px`, left: `${data.art.x}px`, top: `${data.art.y}px` });
    $imageRot.css({ transform: `rotate(${data.art.a}deg)` });
    $image.attr({ src: `${data.art.uri}` });

    if (data.art.uri == '') {
      $art.css({ width: `${data.area.w}px`, height: `${data.area.h}px`, left: `0px`, top: `0px` });
      $image.hide();
      $rotate.hide();
      $artNull.show();
      $remove.hide();
    } else {
      if (data.art.w == 0 && data.art.h == 0) {
        data.art.w = data.area.w;
        $art.css({ width: `${data.area.w}px`, height: `auto`, left: `0px`, top: `0px` });
      }
      $image.show();
      $rotate.show();
      $artNull.hide();
    }
    $blank.attr({ src: `${data.blank.uri}` }).css({ width: `${data.blank.w}px`, height: `${data.blank.h}px` });
  };

  let ministuInit = (data) => {
    sideInit(data);
    propsInit(data);
    toolbarInit();
    dataMSTUset(data);

    let $art = $('#art');
    let $canvas = $('#ministu-canvas');
    if (data.art.uri == '') {
      return;
    }

    $art
      .resizable({
        containment: 'parent',
        aspectRatio: true,
        stop: function (event, ui) {
          let width = Math.round(ui.size.width);
          let height = Math.round(ui.size.height);
          setArtData('w', width);
          setArtData('h', height);
          $art.css({ width: width + 'px', height: height + 'px' });
        }
      })
      .draggable({
        containment: 'parent',
        stop: function (event, ui) {
          setArtData('x', ui.position.left);
          setArtData('y', ui.position.top);
        }
      });
    $('#rotate').on('mousedown', rotate.start);
    $canvas.on('mousemove', rotate.rotate);
    $canvas.on('mouseup', rotate.stop);
  };

  let buttonsInit = (elem, callback) => {
    let $saveBtn = $('.js-ministu-save');
    let $cancelBtn = $('.js-ministu-cancel');
    let $addExternalFileBtn = $('.js-action-addExternalFile');

    $saveBtn.on('click', function () {
      save(elem, callback);
    });
    $cancelBtn.on('click', function () {
      if (callback) {
        return callback(null);
      } else {
        history.back();
      }
    });
    $addExternalFileBtn.on('click', addMockupFile);
  };

  let sideInit = (data) => {
    let $colorsSelect = $('#ministu-side [name="colors"]');
    let $areasSelect = $('#ministu-side [name="areas"]');

    // Panels change
    $areasSelect.select2().on('change', panelChange);

    // Colors change
    $colorsSelect
      .select2({
        templateResult: formatColors,
        templateSelection: formatColors
      })
      .on('change', variantChange);

    $('.compare-img-list')
      .off()
      .on('click', '.compare-img-box', (e) => {
        let target = $(e.target).hasClass('compare-img-box') ? $(e.target) : $(e.target).closest('.compare-img-box');
        let color = target.attr('color');
        if (!color) return;
        $colorsSelect.val(color).trigger('change');
      });
  };

  let toolbarInit = () => {
    $('[data-toggle="tooltip"]').tooltip();
    $('#centerH').on('click', () => {
      centerFrame('H');
    });
    $('#centerV').on('click', () => {
      centerFrame('V');
    });
    $('#remove').on('click', () => {
      removeFrame();
    });
    $('#reset').on('click', reset);
  };

  let formatColors = (opt) => {
    let optimage = $(opt.element).val();
    if (optimage) {
      var colorHex = $(opt.element).attr('data-colorHex');
      colorHex = colorHex ? colorHex : optimage;
      return $(
        `<div class="select2-color-option"><span style="background-color:${colorHex.toLowerCase()}"></span>${optimage}</div>`
      );
    } else return false;
  };

  let variantChange = (e) => {
    let color = $(e.target).val();
    if (!color) return;
    UI.block('#ministu-canvas');
    variantSet(color);
  };

  let panelChange = (e) => {
    let panelType = $(e.target).val();
    let currentArea = $currentPanel.areas.find((f) => {
      return f.panelType == panelType;
    });

    window['DT'].panelChange = true;
    window['MSTU'].changed = true;
    currentArea.frame = $currentData.frame;
    $currentData.frame = null;
    if (currentArea.art == null) {
      currentArea.art = { w: 0, h: 0, x: 0, y: 0, a: 0, uri: '' };
    }
    if ($currentData.art != null && $currentData.art.uri != '') {
      currentArea.art.uri = $currentData.art.uri;
      $currentData.art = null;
      addingArea(currentArea);
      return;
    }

    dataInit(currentArea);
  };

  let variantSet = (color = false) => {
    if (!color) {
      color = $currentPanel.variants[0].color;
      $('#ministu-side [name="colors"]').select2().val(color).trigger('change');
    }
    let variants = $.extend([], $currentPanel.variants);
    let data = _.findWhere(variants, { color: color });

    if (data) {
      let img = new Image();
      img.src = data.blank.uri;
      img.onload = () => {
        let blankW = img.naturalWidth;
        let blankH = img.naturalHeight;

        data.blank.w = blankW;
        data.blank.h = blankH;
        data.area = $currentData.area;
        data.panelType = $currentData.panelType;
        data.art = $currentData.art;
        data.side = $currentData.side;
        data.frame = $currentData.frame;

        data.infoVariants = $.extend([], $currentPanel.variants);
        data = mapping.single(data, getBaseWidth() / blankW);

        propsInit(data);
        dataMSTUset(data);
        UI.unblock('#ministu-canvas');
      };
      img.onerror = () => {
        UI.errorMessage('Error loading as image: ' + this.src);
      };
      return true;
    }
    return false;
  };

  let dataMSTUset = (data) => {
    let changed = window['MSTU'] && window['MSTU'].changed;
    window['MSTU'] = data;
    window['MSTU'].changed = changed;
    window['MSTU'].side = $currentPanel.side;

    dataBinder.dataBind(document.body, window);
  };

  let rotate = (function () {
    var R2D = 180 / Math.PI,
      active = false,
      rotation = 0,
      startAngle = 0,
      center = { x: 0, y: 0 };

    let start = (e) => {
      e.preventDefault();
      e.stopPropagation();

      let height, left, top, width, x, y;
      let $art = $('#art');
      let $img = $('#image');
      $art.draggable('disable').resizable('disable');

      let _ref = $img.get(0).getBoundingClientRect();
      (top = _ref.top), (left = _ref.left), (height = _ref.height), (width = _ref.width);
      center = {
        x: left + width / 2,
        y: top + height / 2
      };
      x = e.clientX - center.x;
      y = e.clientY - center.y;
      startAngle = R2D * Math.atan2(y, x);
      return (active = true);
    };

    let rotate = (e) => {
      let d, x, y;
      let $img = $('#image');
      e.preventDefault();
      x = e.clientX - center.x;
      y = e.clientY - center.y;
      d = R2D * Math.atan2(y, x);
      rotation = d - startAngle;
      if (active) {
        return $img.css('transform', 'rotate(' + Math.round(window['MSTU'].art.a + rotation) + 'deg)');
      }
    };

    let stop = () => {
      $('#art').draggable('enable').resizable('enable');
      let newAngle = $('#image').rotationInfo().deg;
      if (window['MSTU'].art.a != newAngle) setArtData('a', newAngle);
      return (active = false);
    };

    return {
      start,
      rotate,
      stop
    };
  })();

  let save = (elem, callback = false) => {
    mapping.save();
    let result = [];

    $stuData.panels.forEach((item) => {
      item.areas.forEach((area) => {
        if (area.frame) {
          const variants = item.variants
            .filter((variant) => variant.compareFile !== null)
            .map((variantWithFile) => ({
              color: variantWithFile.color,
              colorHex: variantWithFile.colorHex,
              File: variantWithFile.compareFile
            }));
          result.push({ side: item.side, art: area.art, frame: area.frame, panelType: area.panelType, variants });
        }
      });
    });
    if (result.length == 0) return;

    UI.block(elem);


    $.when(App.ajaxData(`DesignStudio/save-mockup/${User.accountID()}/${$stuData.product.id}`, result, 'POST')).done(
      (res) => {
        window['MSTU'].changed = false;
        if (callback) return callback();
        UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });
        UI.unblock(elem);
      }
    );
  };

  let modalInfo = (data) => {
    let out = `${
      data.result ? `<img src="${data.result}" style="position:relative;margin:auto" class="img-thumbnail"><br>` : ``
    }
               <textarea rows="5" class="form-control">${JSON.stringify(data)}</textarea>`;
    bootbox.alert(out);
  };

  let getBaseWidth = () => {
    return $('#blankWrap').width();
  };

  let centerFrame = (dir) => {
    let data = window['MSTU'];
    if (data.art.h == 0) {
      data.art.h = parseFloat($('#art').height().toFixed(2));
    }

    if (data.art.w == 0) {
      data.art.w = parseFloat($('#art').width().toFixed(2));
    }
    if (dir == 'V') {
      let artY = (data.area.h - data.art.h) / 2;
      $('#art').css({ top: Math.round(artY) + 'px' });
      setArtData('y', artY);
    } else if (dir == 'H') {
      let artX = (data.area.w - data.art.w) / 2;
      $('#art').css({ left: Math.round(artX) + 'px' });
      setArtData('x', artX);
    }
  };

  let removeFrame = () => {
    $stuData.panels.forEach((item) => {
      if (item.side === $currentData.side) {
        $currentPanel = item;
      }
    });

    window['MSTU'].changed = true;
    $currentPanel.areas.forEach((item) => {
      item.art = null;
      item.frame = null;
    });

    dataInit();
  };

  let reset = () => {
    if (!window['MSTU'] || !window['MSTU'].changed) return;

    let color = $('#ministu-side [name="colors"]').val();
    UI.block('#ministu-canvas');
    if (window['MSTU'] && window['MSTU'].changed) {
      window['MSTU'].changed = false;
    }
    $('[data-toggle="tooltip"]').tooltip('hide');
    variantSet(color);
  };

  let setArtData = (varName, newVal) => {
    window['MSTU'].art[varName] = newVal;
    window['MSTU'].changed = true;
  };

  let changeArea = (side) => {
    mapping.save();

    UI.block($el);
    let currentPanel = {};
    $stuData.panels.forEach((item) => {
      if (item.side === side) {
        currentPanel = item;
      }
    });

    // Set Current Color As Query Param
    let colorParamQuery = Common.addQuerySearchParams({ key: 'color', value: window['MSTU'].color });
    history.replaceState(null, document.title, colorParamQuery);

    $currentPanel = currentPanel;
    window['MSTU'].panelType = null;
    window['MSTU'].art = null;
    dataInit();
  };

  let registerGlobalEvent = () => {
    $('*').on('shown.bs.modal', unblockModal);
  };

  let unblockModal = () => {
    $('*').off('shown.bs.modal');
    UI.unblock($el);
  };

  let frameModal = () => {
    UI.block($el);
    window['DT'].selectFrameStudio = null;
    window['DT'].selectArtModal = null;
    window['DT'].selectTrimAndStampModal = null;

    registerGlobalEvent();
    if ($currentPanel.side == 4) {
      let parms = {
        action: 'dialog',
        callback: setTrimOrStamp,
        typeModal: 'trims',
        trimsonly: true
      };
      Trims.init(parms);
    } else {
      let parms = {
        action: 'dialog',
        callback: setArtwork
      };
      Artworks.init(parms);
    }
  };

  let setTrimOrStamp = (e) => {
    const selectTrimAndStampModal = App.pageData('selectTrimAndStampModal');
    if (selectTrimAndStampModal == null) {
      return;
    }
    App.pageData('selectFrameStudio', selectTrimAndStampModal);
    window['MSTU'].changed = true;
    let currentArea = $currentData;
    currentArea.frame = {
      title: selectTrimAndStampModal.title,
      brand: selectTrimAndStampModal.brand,
      subbrand: selectTrimAndStampModal.subbrand,
      standartId: selectTrimAndStampModal.standartId,
      objectId: selectTrimAndStampModal.id,
      frameType: selectTrimAndStampModal.typeModal == 'stamps' ? 2 : 1,
      files: selectTrimAndStampModal.files,
      thumbnailImageUri: selectTrimAndStampModal.thumbnailImageUri
    };

    let artFile = _.findWhere(selectTrimAndStampModal.files, { fileType: 1 });
    currentArea.art.uri = artFile && artFile.uri ? artFile.uri : '';

    addingArea(currentArea);
  };

  let setArtwork = (e) => {
    let selectArtModal = App.pageData('selectArtModal');
    if (selectArtModal == null) {
      return;
    }

    App.pageData('selectFrameStudio', selectArtModal);
    window['MSTU'].changed = true;
    let currentArea = $currentData;
    currentArea.frame = {
      title: selectArtModal.title,
      brand: selectArtModal.brand,
      subbrand: selectArtModal.subbrand,
      standartId: selectArtModal.standartId,
      objectId: selectArtModal.id,
      frameType: 0,
      files: selectArtModal.files,
      thumbnailImageUri: selectArtModal.thumbnailImageUri
    };

    let artFile;
    // Check if Thumbnails files exist
    if (selectArtModal.thumbnailMediaFiles?.length) {
      artFile = _.findWhere(selectArtModal.thumbnailMediaFiles, { fileType: 17 });
    } else {
      artFile = _.findWhere(selectArtModal.files, { fileType: 1 });
    }
    currentArea.art.uri = artFile && artFile.uri ? artFile.uri : '';

    addingArea(currentArea);
  };

  let addingArea = (currentArea) => {
    if (currentArea.art == null || currentArea.art.uri == '') {
      return UI.errorMessage('Item files not found');
    }
    let img = new Image();
    img.src = currentArea.art.uri;
    img.onload = () => {
      let scaleW = 1;
      let scaleH = 1;
      let w = img.naturalWidth;
      let h = img.naturalHeight;
      if (w > currentArea.area.w) {
        scaleW = w / currentArea.area.w;
      }

      if (h > currentArea.area.h) {
        scaleH = h / currentArea.area.h;
      }

      let scale = scaleW > scaleH ? scaleW : scaleH;
      currentArea.art.h = h / scale;
      currentArea.art.w = w / scale;

      let marginLeft = 0;
      let marginTop = 0;

      if (currentArea.area.h > currentArea.art.h) {
        marginTop = (currentArea.area.h - currentArea.art.h) / 2;
      }

      if (currentArea.area.w > currentArea.art.w) {
        marginLeft = (currentArea.area.w - currentArea.art.w) / 2;
      }

      currentArea.art.x = marginLeft;
      currentArea.art.y = marginTop;

      window['MSTU'].art = null;
      dataInit(currentArea);
    };

    // Image Loading fail
    img.onerror = function () {
      removeFrame();
      UI.errorMessage('Failed to load picture! Wrong format.');
    };
  };

  let addMockupFile = (e) => {
    e.preventDefault();

    addFileDialog.mockup({
      data: {},
      ok: (data) => {
        window['MSTU'].compareFile.compareFile = data;
        const variantIndex = $currentPanel.variants.findIndex((variant) => variant.color === window['MSTU'].color);
        $currentPanel.variants[variantIndex].compareFile = data;
        $stuData.panels.forEach((item) => {
          if (item.side === $currentPanel.side) {
            item.variants = [...$currentPanel.variants];
          }
        });
        window['MSTU'].changed = true;
      }
    });
  };

  return {
    init,
    modalInfo,
    changeArea,
    frameModal,
    setArtwork
  };
})();
